import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import { Box, Link, useTheme } from '@mui/material';
import Image from 'next/image';
import React, { FC } from 'react';

interface PDFContainerProps {
  url: string;
  downloadUrl: string;
}

const PDFContainer: FC<PDFContainerProps> = ({ url, downloadUrl }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <Image
        src={url}
        alt="PDF Document"
        width={500}
        height={500}
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'contain'
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          backgroundColor: 'rgba(158, 158, 158, 0.5)',
          height: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',

          ':hover': {
            backgroundColor: 'rgba(158, 158, 158, 0.8)'
          }
        }}
      >
        <Link
          sx={{
            color: theme?.palette?.text?.primary,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            gap: '8px'
          }}
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          View and Download File
          <DownloadForOfflineOutlinedIcon
            sx={{
              color: '#fff'
            }}
          />
        </Link>
      </Box>
    </Box>
  );
};

export default PDFContainer;
